import React, { useEffect, useState } from "react"
import { LibraryActions } from "../../../store/stores/library/LibraryStore.Actions"
import { PersonalityFilter } from "../../../entities/filters/PersonalityFilter"
import { PersonalityResults } from "./PersonalityResults"
import { PersonalityViewer } from "./PersonalityViewer"
import { Breadcrumbs } from "../navigation/BreadCrumbs"
import { LibraryRootRoute, PersonalitiesRoute } from "../navigation/LibraryRoutes"
import { Route, Routes, useLocation, useNavigate } from "react-router"
import { Loader } from "../../theming/loader/Loader"
import { useAppDispatch, useAppSelector } from "../../../store/configureStore"
import { NameFilter } from "../../characters/items/filters/NameFilter"
import { ObjectFilter, ObjectFilterInitializer } from "../../../entities/filters/ObjectFilter"

export const PersonalitiesLibrary = () => {
    const { personalities: allPersonalities, allPersonalitiesLoaded, personalitiesError } = useAppSelector(app => app.library);

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!allPersonalitiesLoaded) {
            dispatch(LibraryActions.loadPersonalities());
        }
    }, [dispatch, allPersonalitiesLoaded]);

    const query = new URLSearchParams(location.search);
    const [filterState, setFilterState] = useState(ObjectFilter.CreateFilterFromQuery(query));
    const personalityFilter = new PersonalityFilter(filterState);

    const search = (newState: ObjectFilterInitializer) => {
        personalityFilter.update(newState);
        const query = personalityFilter.generateQueryString();
        navigate(query, { replace: true });
        setFilterState(newState);
    }

    const filteredPersonalities = personalityFilter.filter(allPersonalities);
    return (
        <Routes>
            <Route path=":name" element={<PersonalityViewer />} />
            <Route path="*" element={<>
                <Breadcrumbs crumbs={[LibraryRootRoute, LibraryRootRoute.GetAsChild(PersonalitiesRoute)]} />
                <h1>Personalities</h1>
                <div className="filters">
                    <NameFilter name={filterState.name} onChange={name => search({ ...filterState, name })} />
                </div>
                {allPersonalitiesLoaded && <PersonalityResults personalities={filteredPersonalities} />}
                {!allPersonalitiesLoaded && <Loader>Loading Personalities</Loader>}
            </>} />                
        </Routes>
    )
}